var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSection3A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 38,
    viewBox: "0 0 82 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 81728"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 16308",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3271 0H75.6452V37.4458H73.3271V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 16302",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2.09473C1 1.54244 1.38614 1.09473 1.86246 1.09473H81V37.6084H1V2.09473Z",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3278",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46081 5.40864C5.85419 5.40864 6.17309 5.07997 6.17309 4.67453C6.17309 4.2691 5.85419 3.94043 5.46081 3.94043C5.06743 3.94043 4.74854 4.2691 4.74854 4.67453C4.74854 5.07997 5.06743 5.40864 5.46081 5.40864Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3279",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46081 8.27973C5.85419 8.27973 6.17309 7.95106 6.17309 7.54563C6.17309 7.14019 5.85419 6.81152 5.46081 6.81152C5.06743 6.81152 4.74854 7.14019 4.74854 7.54563C4.74854 7.95106 5.06743 8.27973 5.46081 8.27973Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3280",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46081 11.1499C5.85419 11.1499 6.17309 10.8212 6.17309 10.4157C6.17309 10.0103 5.85419 9.68164 5.46081 9.68164C5.06743 9.68164 4.74854 10.0103 4.74854 10.4157C4.74854 10.8212 5.06743 11.1499 5.46081 11.1499Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3281",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3905 5.40864C8.78388 5.40864 9.10277 5.07997 9.10277 4.67453C9.10277 4.2691 8.78388 3.94043 8.3905 3.94043C7.99712 3.94043 7.67822 4.2691 7.67822 4.67453C7.67822 5.07997 7.99712 5.40864 8.3905 5.40864Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3282",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3905 8.27973C8.78388 8.27973 9.10277 7.95106 9.10277 7.54563C9.10277 7.14019 8.78388 6.81152 8.3905 6.81152C7.99712 6.81152 7.67822 7.14019 7.67822 7.54563C7.67822 7.95106 7.99712 8.27973 8.3905 8.27973Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3283",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3905 11.1499C8.78388 11.1499 9.10277 10.8212 9.10277 10.4157C9.10277 10.0103 8.78388 9.68164 8.3905 9.68164C7.99712 9.68164 7.67822 10.0103 7.67822 10.4157C7.67822 10.8212 7.99712 11.1499 8.3905 11.1499Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23993",
    x: 14.0435,
    y: 2.86719,
    width: 29.1079,
    height: 8,
    fill: "#C4C4C4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection3A);
export default __webpack_public_path__ + "static/media/Section3A.da7a46961379935cd36f24832471d172.svg";
export { ForwardRef as ReactComponent };